import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import { saveVocabWord } from './api';

const OBJECT_ID = /^[0-9a-f]{24}$/i;

/**
 * Saves a word picked in a passage (free for every learner) and says so. No query cache here: the exam
 * runner renders outside one in tests, and the word list refetches whenever it opens.
 */
export function useSaveWord() {
  const { t } = useTranslation();
  // The take-test route is `/tests/take/:id/sessions/:attemptId`, so the word remembers which test it came from.
  const { id } = useParams();
  const testId = id && OBJECT_ID.test(id) ? id : undefined;
  const { toast } = useToast();
  return useCallback(
    async (word: string, context: string) => {
      try {
        const saved = await saveVocabWord(word, context, testId);
        toast({ title: t('vocab.saved', { word: saved.word }), variant: 'success' });
      } catch {
        toast({ title: t('vocab.save_failed'), variant: 'destructive' });
      }
    },
    [t, toast, testId],
  );
}
